export const BOOKMARKS = 'BOOKMARKS';
export const BOOKMARKS_FORM_SUBMITTED_SUCCESS =
  'BOOKMARKS_FORM_SUBMITTED_SUCCESS';

export const BOOKMARKS_MODAL = 'bookmarksModal';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PF4/Bookmarks/BookmarksConstants.js